export enum Metrics {
  SUM_GMV = 'SUM_GMV',
  GMV_SHARE = 'GMV_SHARE',
  DIFF_GMV_SHARE_CATEGORY_BENCHMARK = 'DIFF_GMV_SHARE_CATEGORY_BENCHMARK',
  AVG_ITEM_FILLED = 'AVG_ITEM_FILLED',
  AVG_ITEM_FOUND = 'AVG_ITEM_FOUND',
  AVG_ITEM_REPLACED = 'AVG_ITEM_REPLACED',
  LOST_GMV = 'LOST_GMV',
  DIFF_AVG_ITEM_FOUND_CATEGORY_BENCHMARK = 'DIFF_AVG_ITEM_FOUND_CATEGORY_BENCHMARK',
  AVG_ITEM_FOUND_CATEGORY_BENCHMARK_GMV_GAP = 'AVG_ITEM_FOUND_CATEGORY_BENCHMARK_GMV_GAP',
  AVG_BASKET = 'AVG_BASKET',
  PRODUCT_NAME = 'PRODUCT_NAME',
  BENCHMARK_GMV_SHARE = 'BENCHMARK_GMV_SHARE',
  BENCHMARK_AVG_ITEM_FOUND = 'BENCHMARK_AVG_ITEM_FOUND',
  TOTAL_GMV = 'TOTAL_GMV',
  BENCHMARK_TOTAL_GMV = 'BENCHMARK_TOTAL_GMV',
  BENCHMARK_SUM_GMV = 'BENCHMARK_SUM_GMV',
  AVG_ITEM_FILLED_PRICE = 'AVG_ITEM_FILLED_PRICE',
  AVG_LOST_GMV_PER_STORE = 'AVG_LOST_GMV_PER_STORE',
  AVG_ORDERED_ITEM = 'AVG_ORDERED_ITEM',
  BENCHMARK_AVG_ITEM_FILLED = 'BENCHMARK_AVG_ITEM_FILLED',
  COUNT_ORDER = 'COUNT_ORDER',
  LAST_ETL_UPDATE = 'MAX_UPDATED_AT_DATE_TIME_UTC',

  GMV_SHARE_PCT_DIFF = 'GMV_SHARE_PCT_DIFF',
  AVG_ITEM_FOUND_PCT_DIFF = 'AVG_ITEM_FOUND_PCT_DIFF',
  AVG_ITEM_REPLACED_PCT_DIFF = 'AVG_ITEM_REPLACED_PCT_DIFF',
  AVG_ITEM_FOUND_CATEGORY_BENCHMARK_GMV_GAP_PCT_DIFF = 'AVG_ITEM_FOUND_CATEGORY_BENCHMARK_GMV_GAP_PCT_DIFF',
}

export enum Dimensions {
  DATE_PT = 'DATE_PT',
  WEEK_SAT_PT = 'WEEK_SAT_PT',
  WEEK_SUN_PT = 'WEEK_SUN_PT',
  WEEK_MON_PT = 'WEEK_MON_PT',
  WEEK_TUE_PT = 'WEEK_TUE_PT',
  WEEK_WED_PT = 'WEEK_WED_PT',
  WEEK_THU_PT = 'WEEK_THU_PT',
  WEEK_FRI_PT = 'WEEK_FRI_PT',
  MONTH_PT = 'MONTH_PT',
  INSIGHTS_PORTAL_ORDER_SOURCE = 'INSIGHTS_PORTAL_ORDER_SOURCE',
  FULFILLMENT_TYPE = 'FULFILLMENT_TYPE',
  ALCOHOL = 'ALCOHOL',
  EXPRESS = 'EXPRESS',
  LOYALTY = 'LOYALTY',
  EBT_ITEM = 'EBT_ITEM',
  EBT_ORDER = 'EBT_ORDER',
  FIRST_ORDER = 'FIRST_ORDER',
  VIRTUAL_WAREHOUSE = 'VIRTUAL_WAREHOUSE',
  WAREHOUSE_LOCATION = 'WAREHOUSE_LOCATION',
  WAREHOUSE_LOCATION_STATE = 'WAREHOUSE_LOCATION_STATE',
  WAREHOUSE_LOCATION_CODE = 'WAREHOUSE_LOCATION_CODE',
  WAREHOUSE_LOCATION_GROUP = 'WAREHOUSE_LOCATION_GROUP',
  PARTNER_GEO_DIVISION = 'PARTNER_GEO_DIVISION',
  ORDER_CURRENCY = 'ORDER_CURRENCY',
  WAREHOUSE = 'WAREHOUSE',
  REGION = 'REGION',
  L1_CATEGORY = 'L1_CATEGORY',
  L2_CATEGORY = 'L2_CATEGORY',
  L3_CATEGORY = 'L3_CATEGORY',
  L4_CATEGORY = 'L4_CATEGORY',
  L5_CATEGORY = 'L5_CATEGORY',
  L6_CATEGORY = 'L6_CATEGORY',
  PRODUCT_CATEGORY_ID = 'PRODUCT_CATEGORY_ID',
  RETAILER_PRODUCT = 'RETAILER_PRODUCT',
  RETAILER_PRODUCT_ID = 'RETAILER_PRODUCT_ID',
  CATALOG_PRODUCT_ID = 'CATALOG_PRODUCT_ID',
  PRODUCT_UPC_CODE = 'PRODUCT_UPC_CODE',
  RX_ORDER = 'RX_ORDER',
  INSIGHTS_PORTAL_REPORTING_PLATFORM = 'INSIGHTS_PORTAL_REPORTING_PLATFORM',
  PRODUCT_RRC_CODE = 'PRODUCT_RRC_CODE',
}
